import { render, staticRenderFns } from "./FaqLink.vue?vue&type=template&id=6953dd74&"
import script from "./FaqLink.vue?vue&type=script&lang=js&"
export * from "./FaqLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports